<template>
  <div class="alipdf">
    <!-- <a-button-group size="large">
      <a-button type="primary" @click="prevPage">
        <a-icon type="left"/>上一页
      </a-button>
      <a-button type="primary" @click="nextPage">
        下一页
        <a-icon type="right"/>
      </a-button>
    </a-button-group> -->
    <div class="main">
      <iframe
        allowfullscreen
        id="aliyunPreview"
        frameborder="0"
        scrolling="no"
        src="http://preview.imm.aliyun.com/index.html"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: ["urlParams"],
  components: {
  },
  data() {
    return {
      // urlParams: {
      //   url:
      //     "http://img.dev.eceibs.net/document/intest/vector/8809801e50694b848dba7a5d3dd0e78d",
      //   region: "",
      //   bucket: "",
      //   accessKeyId: "",
      //   accessKeySecret: "",
      //   stsToken: ""
      // }
    };
  },

  mounted() {
    var _this = this;
    window.addEventListener(
      "message",
      function(e) {
        try {
          var res = JSON.parse(e.data);
        } catch (err) {
          return;
        }
        switch (res.action) {
          case "preview.ready":
            _this.sendMessage("preview.init", _this.urlParams);
            break;
        }
      },
      false
    );

    document.addEventListener("gesturestart", function(e) {
      e.preventDefault();
    });

    document.addEventListener(
      "fullscreenchange",
      function() {
        this.setFullScreenState(!!document.fullscreen);
      },
      false
    );
  },
  methods: {
    json2str(obj) {
      return JSON.stringify(obj, function(key, val) {
        if (typeof val === "function") {
          val = val.toString();
        }
        return val;
      });
    },
    setFullScreenState(state) {
      // state true: 全屏状态 false： 退出全屏状态
      console.log("状态w为" + state);
      this.sendMessage("logic.fullscreenchange", { state: state });
    },
    fullScreen() {
      console.log("点击放大");
      var el = document.getElementById("aliyunPreview");
      var fn =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      fn.call(el);
    },
    // 上一页
    prevPage() {
      this.sendMessage("logic.prevPage");
    },
    // 下一页
    nextPage() {
      this.sendMessage("logic.nextPage");
    },
    sendMessage(action, data) {
      let _this = this;
      var iframe = document.getElementById("aliyunPreview");
      iframe.contentWindow.postMessage(
        _this.json2str({ action: action, data: data }),
        "*"
      );
    }
  }
};
</script>


<style  scoped lang="less">
.main {
  display: flex;
  flex-direction: column;
  // height: 100%;
  min-height: calc(100vh - 1.4rem - 0.74rem);
}

#aliyunPreview {
  flex: 1;
  width: 100%;
  height: 100%;
}
</style>



